import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Link from "next/link";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import Grid from "@mui/material/Grid";
import Image from "next/image";
import P8 from "@/public/static/images/process/p-8.png";
import P9 from "@/public/static/images/process/p-9.png";
import P10 from "@/public/static/images/process/p-10.png";
import P11 from "@/public/static/images/process/p-11.png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  height: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 0,
};

export default function MachiningParts() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [image, setImage] = React.useState<any>(null);
  const [productName, setProductName] = React.useState<string | null>(null);

  return (
    <div className="row">
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P8);
              setProductName("オーディオ筐体");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P8}
                  alt="オーディオ筐体"
                  className="card-img"
                  
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  オーディオ筐体
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ押出形材</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      複雑形状品を空調管理された部屋で高精度総削り出し。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P9);
              setProductName("オーディオ筐体");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P9}
                  alt="オーディオ筐体"
                  className="card-img"
                  
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  オーディオ筐体
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ押出形材</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      高い技術力により押出形材の内壁のみを切削。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P10);
              setProductName("オーディオ筐体");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P10}
                  alt="オーディオ筐体"
                  className="card-img"
                  
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  オーディオ筐体
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ押出形材</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      切削、ヘアライン、ブラスト、印字、
                      アルマイト全て社内加工。ゼニヤならではの曲面へのヘアライン加工。金属感を演出。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P11);
              setProductName("車載電装品");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P11}
                  alt="車載電装品"
                  className="card-img"
                  
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  車載電装品
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミダイカストADC</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      センサー目的のため厳格な寸法管理塗装されたダイカスト品に傷をつけず切削加工
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-inner">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
            className="close-btn"
          >
            <CloseIcon />
          </IconButton>
          <Image
            src={image}
            alt="Camera housing"
            className="card-img"
            
            loading="lazy"
          />
          <Typography
            id="modal-modal-title"
            className="modal-modal-title"
            variant="h6"
            component="h2"
          >
            {productName}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
